import { createSelector } from 'reselect'
import getTimeRemainingTemporaryUnlockedSamplesBannerSelect from 'modules/temporary-unlocked-samples/redux/selectors/get-time-remaning'

import isEligibleToTemporaryUnlockedSamplesSelect from 'modules/temporary-unlocked-samples/redux/selectors/is-eligible-to-temporary-unlocked-samples'
import shouldShowModalOrBannerPostSampleSelect from 'modules/post-sample-survey/redux/selectors/should-show-modal-or-banner'
import shouldShowTemporaryUnlockedSamplesBannerSelectUtil from 'modules/temporary-unlocked-samples/redux/selectors/should-show/utils'
import isInGiftingModeGiftSelect from 'modules/gift/redux/selectors/is-in-gifting-mode'

const shouldShowTemporaryUnlockedSamplesBannerSelect = createSelector(
  isEligibleToTemporaryUnlockedSamplesSelect,
  getTimeRemainingTemporaryUnlockedSamplesBannerSelect,
  shouldShowModalOrBannerPostSampleSelect,
  isInGiftingModeGiftSelect,
  (
    isEligibleToTemporaryUnlockedSamples,
    timeRemaining,
    shouldShowPostSampleModalOrBanner,
    isInGiftingMode
  ) => {
    return shouldShowTemporaryUnlockedSamplesBannerSelectUtil({
      isEligibleToTemporaryUnlockedSamples,
      timeRemaining,
      shouldShowPostSampleModalOrBanner,
      isInGiftingMode
    })
  }
)
export default shouldShowTemporaryUnlockedSamplesBannerSelect
